/* The Team link in the header and the mobile drawer.

   It is not in the Shopify navigation menu, because a menu item is the same
   for everybody and this one must not be. It is inserted here instead, and
   only when #gs-ann-state says the signed-in visitor is eligible: a
   grandseal.ae address, or either of the two staff tags.

   WHY ELIGIBLE RATHER THAN TAGGED. Somebody joining has no customer record
   until they sign in once, and no tag until an admin grants one. If the link
   were tag-only they would have nowhere to click and no way to appear in the
   admin's list. So a grandseal.ae address sees the link, lands on the page,
   and reads "your account is not approved yet" - the instruction they need,
   and loading it creates the record the admin then approves.

   The link is only a link. The page gates itself server-side, so showing it
   to somebody untagged gives nothing away.

   BESIDE THE ICONS, NOT IN THE NAV LIST. The first attempt cloned a
   .menu-list__list-item into the top nav. Horizon wraps that nav in an
   <overflow-list>, which measures its children and tips whatever does not
   fit into a "More" bucket - Team went straight in there at 0 by 0 pixels
   and a "More" item appeared to hold it. Worse, removing it to fall back
   woke the MutationObserver, which put it back, which hid it again. So the
   link now goes in .header__column--right just before the icons, where no
   measuring happens. It reads better there anyway: this is a staff door,
   not another section of the website.

   Its CSS is injected from here rather than from a stylesheet because
   gs-team.css only loads on the dashboard itself, and this element lives on
   every page.

   Horizon rebuilds the header on resize and when the drawer opens, so both
   insertions are idempotent and re-run on a MutationObserver. */

(function () {
  'use strict';

  var S = {};
  try {
    var node = document.getElementById('gs-ann-state');
    if (node) S = JSON.parse(node.textContent);
  } catch (err) { return; }

  if (!S.teamEligible) return;

  var LABEL = 'Team';
  var HREF = '/pages/team';

  var css = document.createElement('style');
  css.textContent =
    '.gs-team-pill{display:inline-flex;align-items:center;gap:7px;align-self:center;' +
    'padding:7px 15px;border-radius:999px;font-size:.86rem;font-weight:700;' +
    'letter-spacing:.01em;text-decoration:none;white-space:nowrap;color:inherit;' +
    'background:rgb(255 255 255 / 16%);border:1px solid rgb(255 255 255 / 34%);' +
    'transition:background 180ms,border-color 180ms}' +
    '.gs-team-pill:hover{background:rgb(255 255 255 / 28%);border-color:rgb(255 255 255 / 55%)}' +
    '.gs-team-pill svg{width:15px;height:15px}' +
    '.gs-team-pill.is-here{background:#fff;border-color:#fff;color:#0b2430}' +
    '@media (max-width:989px){.gs-team-pill{display:none}}';
  document.head.appendChild(css);

  var ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M16 20v-1.5a3.5 3.5 0 0 0-3.5-3.5h-5A3.5 3.5 0 0 0 4 18.5V20"/>' +
    '<circle cx="10" cy="8" r="3.2"/><path d="M19.5 20v-1.4a3.3 3.3 0 0 0-2.4-3.1"/>' +
    '<path d="M15 5.2a3.2 3.2 0 0 1 0 5.6"/></svg>';

  function here() {
    return window.location.pathname.replace(/\/+$/, '') === HREF;
  }

  function inHeader() {
    var col = document.querySelector('.header__column--right');
    if (!col || col.querySelector('[data-gs-team-pill]')) return;

    var a = document.createElement('a');
    a.href = HREF;
    a.className = 'gs-team-pill' + (here() ? ' is-here' : '');
    a.setAttribute('data-gs-team-pill', '');
    a.innerHTML = ICON + '<span>' + LABEL + '</span>';
    if (here()) a.setAttribute('aria-current', 'page');

    var icons = col.querySelector('header-actions');
    if (icons) col.insertBefore(a, icons);
    else col.appendChild(a);
  }

  function inDrawer() {
    var items = document.querySelectorAll('.menu-drawer__menu-item--mainlist');
    if (!items.length) return;

    var last = items[items.length - 1];
    var host = last.parentElement;
    if (!host || host.querySelector('[data-gs-team-link]')) return;

    var copy = last.cloneNode(true);
    copy.setAttribute('data-gs-team-link', '');
    copy.setAttribute('href', HREF);
    copy.removeAttribute('aria-current');
    Array.prototype.slice.call(copy.attributes).forEach(function (at) {
      if (at.name.indexOf('on:') === 0 || at.name === 'ref') copy.removeAttribute(at.name);
    });
    copy.textContent = LABEL;
    host.appendChild(copy);
  }

  function run() { inHeader(); inDrawer(); }

  run();

  var soon = null;
  new MutationObserver(function () {
    window.clearTimeout(soon);
    soon = window.setTimeout(run, 80);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
